<template>
  <div>

    <div class="report-wrapper">
      <div class="report-col">
        <div class="consumer-duty-section" v-if="currentReport.products_and_services">
          <div class="consumer-duty-header">
            <h3 class="title">{{ currentReport.products_and_services.title }}</h3>
            <div class="score"
                 v-bind:style="getScoreStyle(currentReport.products_and_services.score)">
              <span>{{ currentReport.products_and_services.score }} %</span>
            </div>
          </div>
          <div class="consumer-duty-resources">
            <div class="resource-item"
                 v-for="(resource, title) in currentReport.products_and_services.resources">
              <div class="title-wrapper"> <div class="title" v-bind:style="getScoreStyle(resource.score)">
                {{ title }}</div></div>
              <div class="fields">
                <div class="resource-field" v-for="field in resource.fields">
                  <div class="title" v-bind:style="getScoreStyle(field.score)">
                    {{ field.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="consumer-duty-section" v-if="currentReport.price_and_value">
          <div class="consumer-duty-header">
            <h3 class="title">{{ currentReport.price_and_value.title }}</h3>
            <div class="score"
                 v-bind:style="getScoreStyle(currentReport.price_and_value.score)">
              <span>{{ currentReport.price_and_value.score }} %</span>
            </div>
          </div>
          <div class="consumer-duty-resources">
            <div class="resource-item"
                 v-for="(resource, title) in currentReport.price_and_value.resources">
              <div class="title-wrapper"> <div class="title" v-bind:style="getScoreStyle(resource.score)">
                {{ title }}</div></div>
              <div class="fields">
                <div class="resource-field" v-for="field in resource.fields">
                  <div class="title" v-bind:style="getScoreStyle(field.score)">
                    {{ field.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="report-col">
        <div class="consumer-duty-section" v-if="currentReport.consumer_understanding">
          <div class="consumer-duty-header">
            <h3 class="title">{{ currentReport.consumer_understanding.title }}</h3>
            <div class="score"
                 v-bind:style="getScoreStyle(currentReport.consumer_understanding.score)">
              <span>{{ currentReport.consumer_understanding.score }} %</span>
            </div>
          </div>
          <div class="consumer-duty-resources">
            <div class="resource-item"
                 v-for="(resource, title) in currentReport.consumer_understanding.resources">
              <div class="title-wrapper"><div class="title" v-bind:style="getScoreStyle(resource.score)">
                {{ title }}</div></div>
              <div class="fields">
                <div class="resource-field" v-for="field in resource.fields">
                  <div class="title" v-bind:style="getScoreStyle(field.score)">
                    {{ field.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="consumer-duty-section" v-if="currentReport.consumer_support">
          <div class="consumer-duty-header">
            <h3 class="title">{{ currentReport.consumer_support.title }}</h3>
            <div class="score"
                 v-bind:style="getScoreStyle(currentReport.consumer_support.score)">
              <span>{{ currentReport.consumer_support.score }} %</span>
            </div>
          </div>

          <div class="consumer-duty-resources">
            <div class="resource-item"
                 v-for="(resource, title) in currentReport.consumer_support.resources">
              <div class="title-wrapper">
                <div class="title" v-bind:style="getScoreStyle(resource.score)">{{ title }}</div>
              </div>
              <div class="fields">

                <div v-if="resource.addFieldValues" class="resource-field resource-field-interactive" v-for="(field, index) in resource.fields" :key="index">
                  <div class="title" v-bind:style="getScoreStyle(field.score)" @click="toggleDropdown(field, resource)">
                    {{ field.title }}
                    <span v-if="!field.open" class="dropdown-icon">▼</span>
                    <span v-if="field.open" class="dropdown-icon">▲</span>
                  </div>
                  <div v-if="field.open" class="dropdown-content dropdown-content-interactive">
                    <p v-for="(value, title, index) in field.fieldValues">
                      {{ index + 1 }}. {{ title }} - {{ value }}
                    </p>
                  </div>
                </div>

                <div v-else class="resource-field" v-for="field in resource.fields">
                  <div class="title" v-bind:style="getScoreStyle(field.score)">
                    {{ field.title }}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="">
      <a href="https://youtu.be/zV5JrjOJQ3Y" target="_blank">Watch Model Office video</a>
      <span> On Model Office MO® Consumer Duty diagnostic, gap analysis, audit reports and gain
                                the
                                data you need to evidence compliance.</span>
    </div>

  </div>
</template>

<script>
export default {
  name: "ConsumerDutyCurrentReportComponent",
  props: [
    "report",
  ],
  data() {
    return {
      currentReport: [],
    }
  },
  mounted() {
    this.currentReport = JSON.parse(this.report);
  },
  methods: {
    getScoreStyle: function (score) {
      let color = '#2ECC71';
      let border = 'transparent';
      if (score == 0) {
        border = '#81c6e9';
        color = 'transparent';
      } else if (score < 34) {
        color = '#DE301D';
      } else if (score < 68) {
        color = '#F1C40F';
      }

      return {
        backgroundColor: `${color} !important`,
        borderColor: `${border} !important`,
        printColorAdjust: 'exact',
      };
    },
    toggleDropdown(field, resource) {
      for (let key in resource.fields) {
        if (resource.fields.hasOwnProperty(key)) {
          const f = resource.fields[key];
          if (f !== field) {
            f.open = false;
          }
        }
      }

      field.open = !field.open
    },
  }

}
</script>

<style scoped>
.resource-field-interactive {
  position: relative;
  cursor: pointer;
}

.dropdown-content-interactive {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  background: white;
  border: 1px solid #ddd;
  padding: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 200px;
}
.dropdown-content-interactive p {
  margin: 0;
}
.dropdown-content-interactive p:not(:last-child) {
  border-bottom: 1px solid grey;
  margin-bottom: 5px;
}
</style>
